var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('nav',[_c('ul',{staticClass:"footer-menu"},[_c('li',[_vm._v("\n          footer-user\n          ")])])])])])
}]

export { render, staticRenderFns }